import { PawPrint, BadgeCheck, ArrowUp } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

const verifiedShelters = [
  { name: "Schronisko w Piotrkowie Trybunalskim", city: "Piotrków Trybunalski, łódzkie" },
  { name: "Schronisko w Kiczarowie", city: "Stargard, zachodniopomorskie" },
  { name: "Schronisko w Chełmie", city: "Chełm, lubelskie" },
  { name: "Schronisko w Milanówku", city: "Milanówek, mazowieckie" },
  { name: "Schronisko w Borku – Fundacja Straż Obrony Praw Zwierząt", city: "Rzezawa, małopolskie" },
  { name: "Schronisko Ciapek", city: "Hajnówka, podlaskie" },
  { name: "Schronisko w Sokółce", city: "Sokółka, podlaskie" },
  { name: "Fundacja Jedno Serce Nie Da Rady", city: "Szumowo, podlaskie" },
];

export const InstagramStoryVerified1 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a", // Fallback color
      }}
    >
      {/* Background image as element for better html-to-image compatibility */}
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />
      {/* Top decorative bar */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "8px",
          background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)",
          zIndex: 2,
        }}
      />

      {/* Safe zone content - 250px margins */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "280px 80px 280px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Header - compact 2 lines */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "40px",
          }}
        >
          <h1
            style={{
              fontSize: "64px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: 0,
              textAlign: "center",
              lineHeight: 1.2,
            }}
          >
            Mamy już <span style={{ color: "#4E8A6E" }}>8</span> zweryfikowanych
          </h1>
          <h1
            style={{
              fontSize: "64px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: 0,
              textAlign: "center",
              lineHeight: 1.2,
            }}
          >
            schronisk! 🎉
          </h1>
        </div>

        {/* Shelters list */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            justifyContent: "center",
          }}
        >
          {verifiedShelters.map((shelter, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.95)",
                borderRadius: "24px",
                padding: "22px 28px",
                display: "flex",
                alignItems: "center",
                gap: "16px",
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
              }}
            >
              <BadgeCheck style={{ width: "36px", height: "36px", color: "#4E8A6E", flexShrink: 0 }} />
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <span style={{ fontSize: "32px", fontWeight: 700, color: "#2D5A3D", lineHeight: 1.2 }}>
                  {shelter.name}
                </span>
                <span style={{ fontSize: "26px", fontWeight: 500, color: "#6B8A7A" }}>
                  📍 {shelter.city}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "48px",
          }}
        >
          <ArrowUp style={{ width: "48px", height: "48px", color: "#4E8A6E" }} />
          <p
            style={{
              fontSize: "40px",
              fontWeight: 700,
              color: "#4E8A6E",
              margin: "12px 0 24px",
              textAlign: "center",
            }}
          >
            Sprawdź ich potrzeby i pomóż! 💚
          </p>

          {/* Logo footer */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <div
              style={{
                background: "#4E8A6E",
                borderRadius: "12px",
                width: "40px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PawPrint style={{ width: "24px", height: "24px", color: "#FFFFFF" }} />
            </div>
            <span style={{ fontSize: "28px", fontWeight: 800, color: "#2D5A3D" }}>
              GdzieSchronisko.pl
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
